/**
 * Takes a function @fn and wraps it in a timeout that expires in @param ms milliseconds.
 */
// eslint-disable-next-line @typescript-eslint/ban-types
export const debounce = (fn: Function, ms: number) => {
	let timeoutId: ReturnType<typeof setTimeout>;
	return (...args: unknown[]) => {
		clearTimeout(timeoutId);
		timeoutId = setTimeout(() => {
			// eslint-disable-next-line prefer-spread
			fn.apply(null, args);
		}, ms);
	};
};
